import { defineMessages } from 'react-intl';

/** design: trial-upsell a3 (viewer), a4 (banner, flag), a5 (post warning), a6 (paid render). */
export const watermarkFileMessages = defineMessages({
  fileTitle: {
    id: 'app.sml.upsell.watermark.callout.file.title',
    defaultMessage: 'This file has the MUSIC24 watermark.',
  },
  halfSize: {
    id: 'app.sml.upsell.watermark.callout.file.halfSize',
    defaultMessage: 'It is also a half-size preview.',
  },
  planGivesTrial: {
    id: 'app.sml.upsell.watermark.callout.file.planGives.trial',
    defaultMessage:
      'A plan gives you the clean file, and clean copies of your {count, plural, one {# trial file} other {# trial files}}.',
  },
  planGivesFree: {
    id: 'app.sml.upsell.watermark.callout.file.planGives.free',
    defaultMessage:
      'A plan gives you the clean file, and clean copies of your {count, plural, one {# file} other {# files}}.',
  },
  planGives: {
    id: 'app.sml.upsell.watermark.callout.file.planGives',
    defaultMessage: 'A plan gives you the clean file.',
  },
  makeTitleTrial: {
    id: 'app.sml.upsell.watermark.callout.make.title.trial',
    defaultMessage: 'On the trial this video is a preview.',
  },
  makeTitleFree: {
    id: 'app.sml.upsell.watermark.callout.make.title.free',
    defaultMessage: 'On Free this video is a preview.',
  },
  makeBody: {
    id: 'app.sml.upsell.watermark.callout.make.body',
    defaultMessage:
      '540p, with the MUSIC24 watermark on every frame. On a plan the same {credits, plural, one {# credit gives} other {# credits give}} you the 1080p video with no watermark.',
  },
  makeFine: {
    id: 'app.sml.upsell.watermark.callout.make.fine',
    defaultMessage:
      'If you make the preview now and get a plan later, we make the clean video for you at no credit cost.',
  },
  makePreview: { id: 'app.sml.upsell.watermark.callout.make.confirm', defaultMessage: 'Make the preview' },
  bannerTitle: {
    id: 'app.sml.upsell.watermark.banner.title',
    defaultMessage: '{count, plural, one {# file carries} other {# files carry}} the MUSIC24 watermark.',
  },
  // QA 2026-10-28 impr2-2, mob-13, lit-8: the banner counts files, the Kit counts kit parts. Say it.
  bannerUnit: {
    id: 'app.sml.upsell.watermark.banner.unit',
    defaultMessage: 'A file is one size of a kit part or one reel, so you have more files than kit parts.',
  },
  bannerBody: {
    id: 'app.sml.upsell.watermark.banner.body',
    defaultMessage: 'A plan makes clean, full-size copies of all {count}. You pay no credits for them.',
  },
  bannerBodyNoCopies: {
    id: 'app.sml.upsell.watermark.banner.bodyNoCopies',
    defaultMessage: 'A plan makes each new file in full size, with no watermark.',
  },
  daysLeft: {
    id: 'app.sml.upsell.watermark.daysLeft',
    defaultMessage: '{days, plural, one {# day} other {# days}} of trial left',
  },
  onFree: { id: 'app.sml.upsell.watermark.onFree', defaultMessage: 'You are on Free' },
  // QA 2026-10-28 (lit-7): "Remove the watermark" opens a purchase. The line under it says so.
  paidPlanFrom: { id: 'app.sml.upsell.watermark.paidPlanFrom', defaultMessage: 'Paid plan, from {price} a month' },
  paidPlan: { id: 'app.sml.upsell.watermark.paidPlan', defaultMessage: 'Paid plan' },
  flag: { id: 'app.sml.upsell.watermark.flag', defaultMessage: 'Watermark' },
  viewerTag: { id: 'app.sml.upsell.watermark.viewer.tag', defaultMessage: 'A plan removes this' },
  factWatermark: { id: 'app.sml.upsell.watermark.viewer.fact.label', defaultMessage: 'Watermark' },
  factWatermarkValue: { id: 'app.sml.upsell.watermark.viewer.fact.value', defaultMessage: 'MUSIC24 mark' },
  factPreviewSize: {
    id: 'app.sml.upsell.watermark.viewer.fact.previewSize',
    defaultMessage: '{width} × {height} · preview',
  },
  postWarning: {
    id: 'app.sml.upsell.watermark.post.warning',
    defaultMessage:
      'Your fans will see the MUSIC24 watermark on this post, on {count, plural, one {# channel} other {# channels}}.',
  },
  postWarningNoChannel: {
    id: 'app.sml.upsell.watermark.post.warningNoChannel',
    defaultMessage: 'Your fans will see the MUSIC24 watermark on this post.',
  },
  planWarning: {
    id: 'app.sml.upsell.watermark.post.planWarning',
    defaultMessage:
      '{count, plural, one {# post of this plan carries} other {# posts of this plan carry}} the MUSIC24 watermark.',
  },
  removeFirst: { id: 'app.sml.upsell.watermark.post.removeFirst', defaultMessage: 'Remove it first' },
  scheduleWithWatermark: {
    id: 'app.sml.upsell.watermark.post.schedule',
    defaultMessage: 'Schedule with the watermark',
  },
});
